import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { UseNav } from '@/components/context/NavContext';
import { useGallery } from '@/components/context/GalleryContext';
import {
  childVariantsUl,
  variantsUl,
  opacity,
} from '../../components/Layout/Nav/anim';

const linkRessources = [
  {
    name: 'Home',
    to: '/',
  },
  {
    name: 'Galleries',
    to: '/galleries',
  },
  {
    name: 'About',
    to: '/about',
  },
];

const Links = () => {
  const { isActive, setIsActive } = UseNav();
  const { setOpenGallery } = useGallery();

  const toggleNav = () => {
    if (isActive) setIsActive(false);
    setOpenGallery((prevState) => ({ ...prevState, showGallery: false }));
  };

  return (
    <motion.ul
      className="flex items-center gap-4 max-sm:ml-20"
      variants={(variantsUl, opacity)}
      initial="hidden"
      animate={!isActive ? 'open visible' : 'closed'}
    >
      {linkRessources.map((link, idx) => (
        <motion.li
          key={idx}
          variants={childVariantsUl}
          initial="hidden"
          animate="visible"
          transition={{
            duration: 1,
            delay: idx * 0.2,
          }}
        >
          <Link to={link.to} className="font-medium" onClick={toggleNav}>
            {link.name}
          </Link>
        </motion.li>
      ))}
    </motion.ul>
  );
};

export default Links;
